import { useRouter } from 'next/navigation';
import { tv } from 'tailwind-variants';
import { Icon } from '@/app_components/common/Icon';
import { Link } from '@/app_components/common/Link';
import { Error500Icon } from '@/app_components/icons/Error500Icon';
import { Button } from '@/app_components/ui/Button';

const errorStyles = tv({
  slots: {
    actionItem: 'flex items-center gap-2',
    actionsWrapper: 'flex flex-col items-start gap-2 self-stretch typography-sm',
    description: 'typography-level-6',
    errorIcon: 'w-[320px] h-[110px] md:w-[468px] md:h-[162px] xl:w-[545px] xl:h-[188px] self-center',
    strongText: 'font-medium',
    title: 'font-inria-serif typography-level-3 font-bold',
    wrapper: 'flex flex-col w-full py-10 px-5 gap-12 lg:flex-row-reverse lg:justify-around h-full',
  },
});

const { wrapper, errorIcon, actionItem, strongText, title, description, actionsWrapper } = errorStyles();

export const InternalError = () => {
  const router = useRouter();

  return (
    <div className={wrapper()}>
      <Error500Icon className={errorIcon()} />
      <div className='flex flex-col gap-10 self-stretch'>
        {/* Title */}
        <div className='flex flex-col gap-6 self-stretch'>
          <h1 className={title()}>Our systems need a quick pivot.</h1>
          <p className={description()}>We’re addressing the issue and hope to have it fixed soon.</p>
        </div>

        {/* Actions */}
        <div className={actionsWrapper()}>
          <p>Here’s what you can do in the meantime:</p>
          <ul className='flex flex-col pl-2 gap-4'>
            <li className={actionItem()}>
              <Icon icon='RefreshCw' />
              <p>Refresh the page</p>
            </li>
            <li className={actionItem()}>
              <Icon icon='Clock' />
              <p>
                <span className={strongText()}>Visit our homepage</span> to explore our latest stories.
              </p>
            </li>
            <li className={actionItem()}>
              <Icon icon='Mail' />
              <p>
                <span className={strongText()}>
                  Reach out to us at{' '}
                  <Link
                    aria-label='share with email'
                    className='text-link'
                    href='mailto:support@fortune.com'
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    support@fortune.com
                  </Link>
                </span>{' '}
                if you need assistance or have questions.
              </p>
            </li>
          </ul>
        </div>

        {/* Homepage */}
        <div className='contents md:block'>
          <Button
            className='normal-case'
            onClick={() => router.push('/')}
            variant='primary'
          >
            Go to homepage <Icon icon='ChevronRight' />
          </Button>
        </div>
      </div>
    </div>
  );
};
